import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import ArrowUpIconSvg from './icon-arrow-up.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ArrowUpIconSvg {...validProps} />;
}
SvgComponent.iconName = 'arrowUpIcon';

/**
 * @deprecated This is a legacy icon
 */
export const ArrowUpIcon = svgIconWrapper(SvgComponent);
